import { isNgTemplate } from "@angular/compiler";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { ModalFormConstants } from "../models/modal-form.model";

@Component({
  selector: "app-modal-form",
  templateUrl: "./modal-form.component.html",
  styleUrls: ["./modal-form.component.scss"],
})
export class ModalFormComponent {
  closeResult = "";

  @ViewChild("content") content: ElementRef<HTMLInputElement>;
  @ViewChild("confirmSwal")
  public readonly confirmSwal!: SwalComponent;

  @Input() title: string;
  @Input() locatorClass: string;
  @Input() confirmMessage: string;
  @Output() sendForm = new EventEmitter<any>();

  formLabelAndKeyArray: ModalFormConstants[];
  textMessage: string = "";
  type: string = "";

  constructor(
    private modalService: NgbModal,
    private toastrAlertService: ToastrAlertService
  ) {}

  onSave() {
    if (this.validate()) {
      this.modalService.dismissAll();
      this.confirmSwal.fire().then((result) => {
        if (result.isConfirmed) {
          this.sendForm.emit({
            form: this.formLabelAndKeyArray,
            type: this.type,
          });
          this.resetValues();
        }
      });
    } else {
      this.toastrAlertService.toastrFail(this.textMessage);
    }
  }

  resetValues() {
    this.formLabelAndKeyArray.forEach((element) => {
      element.value = "";
    });
  }

  validate(): boolean {
    let value = true;
    this.textMessage = "";
    this.formLabelAndKeyArray.forEach((element) => {
      if (
        element.required &&
        element.value == "" &&
        element.type != "checkbox"
      ) {
        if (value) {
          this.textMessage = element.label + " (requerido) ";
        } else {
          this.textMessage =
            this.textMessage + ", <br/>" + element.label + " (requerido)";
        }
        value = false;
      }
    });
    return value;
  }

  open(formLabelAndKeyArray: any, value: string) {
    this.formLabelAndKeyArray = formLabelAndKeyArray;
    this.type = value;
    this.modalService
      .open(this.content, {
        ariaLabelledBy: "modal-basic-title",
        centered: true, size: value
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  checkElement(item) {
    item.value = item.value ? false : true;
  }

  elementSelectOfList(value: any, item: any) {
    let pos = this.formLabelAndKeyArray.findIndex((e) => item.label == e.label);

    if (value && value.item && value.item[value.id]) {
      this.formLabelAndKeyArray[pos].value = value.item[value.id];

      if (this.type === "RE") {
        let descIndex = this.formLabelAndKeyArray.findIndex(
          (e) => e.key == "tcDescr"
        );
        document.getElementById("tcDescr")["value"] = value.item["descr"];
        this.formLabelAndKeyArray[descIndex].value = value.item["descr"];
      }
    }
  }

  public getInitialValue(field: ModalFormConstants): any {
    let key =
      Array.isArray(field.key) && field.key.length > 0
        ? field.key[0]
        : field.key;

    return field.list.find((e) => e[key] === field.value);
  }
  
  public autoExpand(event: any): void {
      let element = event.target;
      element.style.height = "5px";
      element.style.height = element.scrollHeight + "px";
  }
}
